module.exports = __webpack_public_path__ + "static/felicita-5febf163405ecd6c5f70a11d52546931.jpg";